import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import CaseDomainForm from "components/forms/CaseDomainForm";
import { getNextQueryParams } from "components/helpers";
import FormDialog from "components/modals/FormDialog";
import CaseDomainService from "services/CaseDomain";
import {
  invalidateCaseDomainsQuery,
  useCaseDomainsTable,
} from "hooks/useCaseDomainsTable";

export const CASE_DOMAINS_TABLE_CONSTANTS = {
  tableName: "case_domains",
  queryKey: "case-domains",
  header: "Case Domains",
  headerIcon: "globe",
  className: null,
  exportTableName: null,
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.caseDomains.create];

const CaseDomainsTableV3 = () => {
  const { columns } = useCaseDomainsTable();

  const fetchCaseDomains = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);
        const response = await CaseDomainService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching case domains:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={CASE_DOMAINS_TABLE_CONSTANTS.headerIcon}
      header={CASE_DOMAINS_TABLE_CONSTANTS.header}
      tableName={CASE_DOMAINS_TABLE_CONSTANTS.tableName}
      queryKey={CASE_DOMAINS_TABLE_CONSTANTS.queryKey}
      fetchData={fetchCaseDomains}
      invalidateData={invalidateCaseDomainsQuery}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <FormDialog
            FormComponent={CaseDomainForm}
            modelType="Case Domain"
            onSuccess={invalidateCaseDomainsQuery}
          />
        </Authorized>
      }
      enableSearch
      enableSettings
    />
  );
};

export default CaseDomainsTableV3;
